import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
	active: false,

  // form
  serviceId: null,
  appliedContentsId: null,
  values: {}
}

const getters = {
	get: state => state,
  
  // 登録値を表示用に変換
  getValue: state => (key) => {
    try {
      let value = state.values[key]
      switch (key) {
        case 'snapshotName':
        case 'snapshotTag':
        case 'versionName':
        case 'releaseNote':
          return state.values.contentsSnapshot[key]
        case 'snapshotCreatedAt':
          return Utility.dateFormat(state.values.contentsSnapshot[key], 'YYYY/MM/DD HH:mm')
        default:
          return value
      }
    /* eslint-disable no-new */
    } catch (e) {
      return ''
    }
  }
}

const actions = {
  show ({commit}, {serviceId, appliedContentsId}) {
    commit('setServiceId', serviceId)
    commit('setAppliedContentsId', appliedContentsId)

		// cover
		this.dispatch('core/showModalCover')
		
		commit('showed')
	},
	hide ({commit}) {
		if (!state.active) return
		commit('hided')
		
		// cover
		setTimeout(() => {
			this.dispatch('core/hideModalCover')
		}, 350)
  },

  /**
   * 初期データを読出し
   */
  loadModel ({commit}) {
    return new Promise((resolve, reject) => {
      let contentsApplyParams = {
        serviceUuid: state.serviceId,
        appliedContentsUuid: state.appliedContentsId
      }

      ApiManager.request(
        ['serviceContentsApply'],
        ['v1ServiceContentsApplyDetailGet'],
        [contentsApplyParams])
        .then(res => {
          let status = Utility.parseResponse(res)
          console.log(res)

          if (status.result) {
            commit('setValues', res[0].data.serviceAppliedContentsDetails)
            console.log('values', state.values)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },
  
  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
	showed (state) {
		state.active = true
	},
	hided (state) {
    state.active = false
	},

  // form
  setServiceId (state, id) {
    state.serviceId = id
  },
  setAppliedContentsId (state, id) {
    state.appliedContentsId = id
  },
  setValues (state, values) {
    Vue.set(state, 'values', values)
  },

  // reset
  reset (state) {
    state.targetId = Constants.RegisterHash
    Vue.set(state, 'values', {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
